<template>
  <div>
    <vs-row>
      <!-- {{selected}} -->
      <!-- <pre>{{lessonLists}}</pre> -->
      <vs-col
        vs-type="flex"
        vs-justify="flex-start"
        vs-align="flex-start"
        vs-w="12"
      >
        <vx-card title="Select View" class="mb-4">
          <!-- Subject Component -->
          <vs-row>
            <subject-listing
              @filterSubjectEvent="filterBySubject"
              @SearchCourseEvent="seachOvaralll"
            ></subject-listing>
            <vs-col
              vs-lg="2"
              vs-sm="12"
              vs-xs="12"
              vs-type="flex"
              vs-justify="flex-end"
              class="p-1"
            >
              <vs-button
                type="filled"
                @click="
                  $router
                    .push({
                      name: 'lesson',
                    })
                    .catch(() => {})
                "
                v-if="checkCreatePermission()"
                >Create</vs-button
              >
            </vs-col>
          </vs-row>
          <!-- Subject Component -->
        </vx-card>
      </vs-col>

      <vs-col
        vs-type="flex"
        vs-justify="flex-end"
        vs-align="flex-start"
        vs-w="12"
      >
        <vs-card class="cstm_vx_card mb-4">
          <!-- <div slot="header">
            <div class="flex flex-wrap items-center">
              <div class="p-1 xl:w-11/12 w-full">
                <v-select
                  class="w-full"
                  placeholder="Enter tags to search"
                  label="name"
                  :reduce="option => option.id"
                  :options="tagModuleWise"
                  v-model="tagSearch"
                  :clearable="false"
                  data-vv-name="tag_list"
                  name="tag_list"
                  multiple
                ></v-select>
              </div>
              <div class="p-1 xl:w-1/12 w-full text-left xl:text-right">
                <vs-button class="w-full" @click="tagSearchWise"
                  >Search</vs-button
                >
              </div>
            </div>
          </div> -->
          <div>
            <div
              class="text-right"
              v-if="isRowSelected && checkDeletePermission()"
            >
              <div class="bulk_holder">
                <a @click="bulkDelete">
                  Bulk Delete
                </a>
              </div>
            </div>
            <ag-grid-vue
              class="ag-theme-material w-100 my-4 ag-grid-table"
              :frameworkComponents="frameworkComponents"
              :tooltipMouseTrack="true"
              :gridOptions="gridOptions"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="rowData"
              rowSelection="multiple"
              :enableRtl="$vs.rtl"
              colResizeDefault="true"
              :animateRows="true"
              :floatingFilter="false"
              :pagination="true"
              :paginationPageSize="paginationPageSize"
              :suppressPaginationPanel="true"
              @grid-ready="onGridReady"
              @sortChanged="sortFun"
            >
            </ag-grid-vue>
            <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
              <vs-col
                vs-w="4"
                vs-type="flex"
                vs-justify="start"
                vs-align="center"
              >
                <!-- page limit select view -->
                <ItemsPerTableDropdown
                  tableName="lesson_table"
                  @change="pageLimit => (pageLimitSet = pageLimit)"
                />
              </vs-col>
              <pagination
                :meta="meta"
                @page-change="handlePageChange"
                class="ml-auto"
              />
            </vs-row>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-popup title="Warning" :active.sync="additionalPopUp">
      <h3>
        One or more lessons could not be deleted as they are referred somewhere
        else.
      </h3>
      <vs-list>
        <vs-list-item
          v-for="(item, index) in nonDeletableItems"
          :key="index"
          :title="item"
        ></vs-list-item>
      </vs-list>
    </vs-popup>
  </div>
</template>

<script>
// import { StatusMixin } from './mixins/StatusMixin'
import vSelect from 'vue-select'
import { newlessonListing } from '@/api/courseBuilder'
import subjectListing from './subjectListing.vue'
import CellActiveRender from './cellActive.vue'
import { mapGetters, mapActions } from 'vuex'
import { DeleteMixin } from './mixins/DeletingMixins'
import { Tag } from '@/mixins/tag/tag'
import Vue from 'vue'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CustomTooltip from '../../v1/coursework/components/CourseWork/customTooltipVue'
import SubjectComponent from '../../course-builder/ListingComponent/Course/courseSubjectComponent.vue'
import courseTag from '@/views/pages/course-builder/ListingComponent/Course/courseTag.vue'
import CellRendererAction from './cellRendererLesson'

import { PaginationData } from '@/mixins/pagination'

import Pagination from '@/components/common/pagination'

import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'

export default {
  components: {
    vSelect,
    subjectListing,
    Pagination,
    Vue,
    AgGridVue,
    CustomTooltip,
    SubjectComponent,
    courseTag,
    CellRendererAction,
    CellActiveRender
  },
  mixins: [DeleteMixin, Tag, PaginationData, PermissionMiddleware],
  computed: {
    ...mapGetters(['get_homework_subject_id', 'get_lesson_deleted_id']),
    selectedLength () {
      if (this.selected.length > 1) {
        return true
      }
    }
  },
  mounted () {
    this.fetchLessonList()
    this.SET_HOMEWORK_SUBJECT_ID(null)
    this.fetchTag(this.platform_module_id)
    // this.gridApi = this.gridOptions.api
    // this.gridColumnApi = this.gridOptions.columnApi
  },
  created () {
    // this.gridApi = this.gridOptions.api
    // this.gridOptions.api.sizeColumnsToFit()
    //this.checkingQuery('/pages/lessonlist')
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission == 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Course')
    }
  },
  beforeMount () {
    this.tooltipShowDelay = 0
    this.frameworkComponents = {
      customTooltip: CustomTooltip
    }
    this.columnDefs = [
      {
        headerName: '',
        minWidth: 60,
        maxWidth: 60,
        field: 'isSelected',
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: '#',
        field: 'row_index',
        filter: false,
        minWidth: 60,
        maxWidth: 100,
        resizable: true,
        editable: false,
        sortable: false,
        valueGetter: 'node.rowIndex + 1'
      },
      {
        headerName: 'Name',
        field: 'name',
        filter: true,
        minWidth: 60,
        resizable: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Description',
        field: 'description',
        filter: true,
        minWidth: 120,
        resizable: true,
        editable: false
      },
      {
        headerName: 'Subject',
        field: 'subjects',
        filter: true,
        minWidth: 100,
        resizable: true,
        editable: false,
        cellRendererFramework: Vue.extend(SubjectComponent),
        tooltipField: 'subject',
        tooltipComponentParams: { color: '#fff' },
        floatingFilterComponentParams: {
          suppressFilterButton: false
        }
      },
      {
        headerName: 'No. of Topics',
        field: 'no_of_topics',
        filter: true,
        minWidth: 100,
        resizable: true,
        editable: false
      },
      {
        headerName: 'No.of Files',
        field: 'no_of_files',
        filter: true,
        minWidth: 120,
        resizable: true,
        editable: false
      },
      /*  {
        headerName: 'Tags',
        field: 'tags',
        filter: true,
        minWidth: 120,
        resizable: true,
        editable: false,
        cellRendererFramework: Vue.extend(courseTag),
        cellRendererParams: { type: 'lessonTags' }
      }, */
      {
        headerName: 'Active',
        field: 'active',
        minWidth: 100,
        resizable: true,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(CellActiveRender)
      },
      {
        headerName: 'Actions',
        field: 'actions',
        minWidth: 100,
        maxWidth: 100,
        resizable: true,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(CellRendererAction),
        cellRendererParams: {}
      }
    ]
  },
  methods: {
    ...mapActions(['SET_HOMEWORK_SUBJECT_ID']),
    getCorrectFieldName (colId) {
      let field_name = colId
      if (colId === 'subjects') {
        field_name = 'subject'
      }

      return field_name
    },
    async sortFun () {
      try {
        const sortState = this.gridApi.getSortModel()
        if (sortState.length == 0) {
          this.sorting_obj.field_type = ''
          this.sorting_obj.attribute = ''
          this.sorting_obj.direction = ''
          this.fetchLessonList()
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = this.getCorrectFieldName(
            sortState[0].colId
          )
          this.sorting_obj.direction = sortState[0].sort

          this.$vs.loading({
            text: 'Loading...'
          })
          this.fetchLessonList()
        }
      } catch (e) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map(node => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    },
    paginationPageSize () {
      return this.pageLimitSet
    },
    seachOvaralll (search) {
      this.search = search
      this.fetchLessonList()
    },
    filterBySubject (subject_ids) {
      this.tagSearch = []
      if (subject_ids == 0) {
        this.subject_ids = false
      } else {
        this.subject_ids = subject_ids
      }
      this.fetchLessonList()
    },
    tagSearchWise () {
      this.subject_ids = false
      this.fetchLessonList()
    },
    async fetchLessonList () {
      try {
        this.$vs.loading({
          text: 'Fetching Lesson please wait ...'
        })
        let payload = {}
        if (this.subject_ids) {
          payload = {
            subject_ids: [this.subject_ids],
            is_visible: true
          }
        } else {
          payload = {
            tag_ids: this.tagSearch,
            is_visible: true
          }
        }
        const customer_id = this.$store.getters.customerId
        //const queryParams = this.$route.query || {}
        //this.query_page.page = queryParams.page || 1
        payload.search = this.search
        payload.limit = this.pageLimitSet
        const responeList = await newlessonListing(
          customer_id,
          payload,
          this.query_page.page,
          this.sorting_obj
        )

        this.lessonLists = responeList.data.data.lesson
        this.meta = responeList.data.data.meta
        this.rowData = this.lessonLists
      } catch (error) {
        //
      } finally {
        this.$vs.loading.close()
      }
    },
    //redirecting for editing

    loadMore () {
      this.loadMoreData()

      //   const customerId = this.$store.getters.customerId
      //   const payload = {
      //     subject_id: '36'
      //   }
      //   const { data } = await fetchQuestionBank(customerId, payload,  this.query_page.current_page + 1)
      //
    },
    async loadMoreData () {
      let payload = {}
      if (this.subject_ids) {
        payload = {
          subject_ids: [this.subject_ids]
        }
      } else {
        payload = {
          tag_ids: this.tagSearch
        }
      }
      payload.limit = this.pageLimitSet
      const customer_id = this.$store.getters.customerId
      const {responeList }= await newlessonListing(
        customer_id,
        payload,
        this.query_page.current_page + 1,
        this.sorting_obj
      )
      // this.question_details = [...this.question_details, data.data.question_details]

      this.lessonLists.push(...responeList.data.lesson)

      this.query_page = responeList.data.meta
    },
    handlePageChange (page) {
      //
      /* const queryPayload = Object.assign({}, this.$route.query)
      queryPayload.page = page */
      /* const pageScroll = document.documentElement.scrollTop
      this.$router.replace({ path: '/pages/lessonlist', query: queryPayload  }).catch(() => {}).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
      // this.fetch_list(queryPayload)
      this.query_page.page = page || 1
      this.fetchLessonList()
    }
  },
  watch: {
    get_lesson_deleted_id () {
      if (this.get_lesson_deleted_id) {
        const table = this.rowData
        for (const delete_id_itr of this.get_lesson_deleted_id) {
          for (let i = 0; i < table.length; i++) {
            if (delete_id_itr === table[i].id) {
              table.splice(i, 1)
            }
          }
        }

        table.map((row, index) => {
          row.row_index = index + 1
        })
        this.rowData = table
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    },
    get_homework_subject_id () {
      const data = this.get_homework_subject_id

      const payload = {
        subjects_ids: [data]
      }

      this.fetchLessonList(payload)
      // fetchAssignmentListconst
    }
  },
  data () {
    return {
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      isRowSelected: false,
      frameworkComponents: null,
      gridApi: null,
      gridOptions: {
        accentedSort: true
      },
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true,
        tooltipComponent: 'customTooltip'
        // autoHeight: true
      },
      rowData: [],
      columnDefs: [],
      pageLimitSet: 5,
      search: '',
      subject_ids: false,
      platform_module_id: 3,
      listingtype: 'lesson',
      courseLists: [],
      lessonLists: [],
      tagSearch: [],
      selected: [],
      courses: [
        {
          id: '1',
          size: '1.34KB',
          image: 'download.png',
          text: 'Instrumental Pro',
          file: 'Piano Course',
          count: '10'
        },
        {
          id: '2',
          size: '1.34KB',
          image: 'download.png',
          text: 'Trial Lesson',
          file: 'Synthesizer Course',
          count: '16'
        },
        {
          id: '3',
          size: '1.34KB',
          image: 'download.png',
          text: 'Little Genius',
          file: 'Guitar Course',
          count: '4'
        }
      ]
    }
  }
}
</script>
